import React from "react";
import { useTranslation } from "react-i18next";
import useLanguage from "../../utils/useLanguage";

const PrintableOrderView = React.forwardRef(
  ({ data, currency, measuringUnit, orderDetails }, ref) => {
    const { currentDirection } = useLanguage();
    const { t } = useTranslation("general");

    const {
      orderNumber = "12345",
      date = new Date().toLocaleDateString(),
      companyName = "",
      createdBy = "",
    } = orderDetails || {};

    return (
      <div
        ref={ref}
        className="printable-order-view"
        dir={currentDirection}
        style={{ display: "none" }}
      >
        <section className="print-first-section">
          <div className="print-header">
            <h1>{t("fabricOrderList")}</h1>
          </div>

          {/* Order information section */}
          <div className="print-info-section">
            <div className="print-info-row">
              <div className="print-info-block">
                <div className="print-info-item">
                  <strong>{t("Date")}:</strong> {date}
                </div>
                <div className="print-info-item">
                  <strong>{t("orderNumber")}:</strong> {orderNumber}
                </div>
              </div>

              <div className="print-info-block">
                <div className="print-info-item">
                  <strong>{t("organizationName")}:</strong> {companyName}
                </div>
                <div className="print-info-item">
                  <strong>{t("createdBy")}:</strong> {createdBy}
                </div>
              </div>
            </div>
          </div>

          {/* Fabric data section */}
          {data.map((fabric) => (
            <div key={fabric.code} className="print-fabric-block">
              <div className="print-fabric-header">
                <h3>
                  {t("code")}: {fabric.code}
                </h3>
              </div>

              <table className="print-fabric-table">
                <thead>
                  <tr>
                    <th>{t("colorCode")}</th>
                    <th>{t("colorName")}</th>
                    <th>
                      {t("quantity")} ({t(measuringUnit.title)})
                    </th>
                    <th>
                      {t("price")} ({t(currency.value)})
                    </th>
                    <th>{t("totalAmount")}</th>
                  </tr>
                </thead>
                <tbody>
                  {fabric.colors.map((color) => (
                    <tr key={color.colorCode}>
                      <td>{color.colorCode}</td>
                      <td>{color.colorName}</td>
                      <td>{color.quantity || 0}</td>
                      <td>{color.price || 0}</td>
                      <td>{(color.quantity || 0) * (color.price || 0)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </section>

        <section className="print-footer u-margin--top_auto">
          <p className="t-headline-3">{t("ehsiblySecondSlogan")}</p>
          <p>{t("alhabbarSlogan")}</p>
        </section>
      </div>
    );
  }
);

export default PrintableOrderView;
